import { RoiDefinition, RoasDefinition } from 'components/NameDefinition';
import SpentFormatter from 'components/tables/NinjaTable/formatters/SpentFormatter';
import RoiFormatter from 'components/tables/NinjaTable/formatters/RoiFormatter';
import RoasFormatter from 'components/tables/NinjaTable/formatters/RoasFormatter';
import ValueDotFormatter from 'components/tables/NinjaTable/formatters/ValueDotFormatter';

export const integrationMetricList = {
  ad_spent: {
    color: '#eb2f20',
    name: 'Ad Spent',
    formatter: SpentFormatter,
    show: true,
    type: 'bar',
    currency: true,
  },
  net_profit: {
    color: '#91c716',
    name: 'Net Profit',
    valueFormatter: ValueDotFormatter,
    show: true,
    currency: true,
    type: 'bar',
  },
  gross_profit: {
    color: '#536A8B',
    name: 'Gross Profit',
    valueFormatter: ValueDotFormatter,
    currency: true,

    type: 'bar',
  },
  gross_income: {
    color: '#ffbb02',
    name: 'Gross Income',
    valueFormatter: ValueDotFormatter,
    currency: true,

    type: 'bar',
  },
  roi: {
    color: '#ff4e00',
    name: 'ROI',
    type: 'line',
    formatter: RoiFormatter,
    opacity: 0.7,

    symbol: '%',
    definition: RoiDefinition,
  },
  roas: {
    color: '#F09319',
    name: 'ROAS',
    type: 'line',
    formatter: RoasFormatter,
    opacity: 0.7,

    definition: RoasDefinition,
  },
  avg_order_value: { color: '#3B6F3A', name: 'Avg. Order Value', currency: true },
  cac: { color: '#5A8F53', name: 'CAC', currency: true },
  avg_profit_per_order: {
    color: '#7A9E5E',
    name: 'Avg. Profit Per Order',
    currency: true,
  },
  new_customer_orders: { color: '#A0C68F', name: 'New Customer Orders' },
  orders: { color: 'rgb(145, 199, 22)', name: 'Orders' },
  deals_cogs: { color: '#9DC08B', name: 'COGS', currency: true },
  refund_rate: { color: '#9DC08B', name: 'Refund Rate', symbol: '%' },
  quantity: { color: '#9DC08B', name: 'Unit Sold' },
  ltv: { color: '#9DC08B', name: 'Lifetime Value', currency: true },
  repeat_customer_percentage: {
    color: '#9DC08B',
    name: 'Repeat Customer Percentage',

    symbol: '%',
  },
  new_customer_percentage: {
    color: '#9DC08B',

    name: 'New Customer Percentage',
    symbol: '%',
  },
  repeat_customer_orders: {
    color: '#9DC08B',
    name: 'Repeat Customer Orders',
  },
};
